import Vue from "Vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Notification } from "../../../models/notification";

@Component
export default class NotificationListHeader extends Vue {
	@Prop()
	public listNotificationFiltred: Notification[] = [];

	public flagList = false;

	@Watch("listNotificationFiltred")
	public listenChange(): void {
		this.flagList = !this.flagList;
	}
}




// WEBPACK FOOTER //
// ./src/shared/components/notification/notification-list-header/notification-list-header.ts